export default __webpack_public_path__ + "static/media/Omron.3c35fe24.png";